<template>
  <div class="fixed inset-0 bg-gradient-to-br from-blue-50 to-indigo-100 overflow-y-auto z-50 pt-24 pb-12">
    <div class="max-w-6xl mx-auto px-4 mt-6">
      <button
        type="button"
        @click="goBack"
        class="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-6 transition"
      >
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
        </svg>
        <span>Voltar</span>
      </button>

      <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
        <!-- Coluna esquerda: formulário -->
        <div class="bg-white rounded-2xl shadow-xl p-8 md:p-10 order-2 lg:order-1">
          <div class="text-center mb-8">
            <h1 class="text-3xl font-bold text-gray-900">TripDay</h1>
            <p class="text-gray-600 mt-2">Crie sua Conta de Anfitrião</p>
          </div>

          <form @submit.prevent="handleRegister" class="space-y-4">
          <!-- Tenant Info -->
          <div class="border-b pb-4 mb-4">
           
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-1">Nome da sua Empresa *</label>
              <input
                v-model="form.tenant.name"
                type="text"
                placeholder="Ex: Xpto Locações para Temporada"
                required
                class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
              />
            </div>

            <div class="mt-3">
              <label class="block text-sm font-medium text-gray-700 mb-1">Nome para seu Ambiente *</label>
              <input
                v-model="form.tenant.master_code"
                type="text"
                placeholder="Ex: xpto-locacoes"
                @input="validateMasterCode"
                maxlength="25"
                required
                class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
              />
              <p v-if="masterCodeError" class="text-xs text-red-600 mt-1">{{ masterCodeError }}</p>
              <p class="text-xs text-gray-500 mt-1">
                <span class="font-semibold">O Ambiente</span> é o identificador único onde os dados dos seus imóveis ficarão salvos no TripDay.
                Use apenas letras, números, hífen e underscore, sem espaços ou acentos
                (ex: <span class="font-mono">pousada-sol-nascente</span>). <span class="font-semibold text-red-600"><br>* Anote esse nome, pois ele será usado no login e para divulgação da sua página.</span>
              </p>
            </div>            

            <div class="mt-3">
              <label class="block text-sm font-medium text-gray-700 mb-1">Telefone principal da empresa *</label>
              <input
                v-model="form.tenant.phone"
                type="tel"
                placeholder="(00) 00000-0000"
                @input="onTenantPhoneInput"
                required
                class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
              />
              <p class="text-xs text-gray-500 mt-1">É obrigatório ser um WhatsApp.</p>
            </div>

            <div class="mt-3 grid grid-cols-1 md:grid-cols-2 gap-3">
              <div>
                
                <label class="block text-sm font-medium text-gray-700 mb-1">Cidade *</label>
                <input
                  v-model="form.tenant.city"
                  type="text"
                  placeholder="Ex: São Paulo"
                  required
                  class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                />
              </div>
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">UF *</label>
                <select
                  v-model="form.tenant.state"
                  required
                  class="w-full px-4 py-2 border border-gray-300 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500"
                >
                  <option value="">Selecione</option>
                  <option
                    v-for="uf in stateOptions"
                    :key="uf.value"
                    :value="uf.value"
                  >
                    {{ uf.label }} ({{ uf.value }})
                  </option>
                </select>
              </div>
            </div>

            <div class="mt-3">
              <label class="block text-sm font-medium text-gray-700 mb-1">Perfil do Instagram</label>
              <input
                v-model="form.tenant.instagram_profile"
                type="text"
                placeholder="Ex: https://instagram.com/seu_perfil"
                class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
              />
            </div>

            <div class="mt-3">
              <label class="block text-sm font-medium text-gray-700 mb-1">Perfil do Facebook</label>
              <input
                v-model="form.tenant.facebook_profile"
                type="text"
                placeholder="Ex: https://facebook.com/sua_pagina"
                class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
              />
              <p class="text-xs text-gray-500 mt-1">Informe pelo menos um dos perfis (Instagram ou Facebook).</p>
            </div>
          </div>

          <!-- User Info -->
          <div class="border-b pb-4 mb-4">
            <h3 class="text-sm font-semibold text-gray-700 mb-3">Dados do seu Usuário (para login no ambiente)</h3>
            
              <div class="grid grid-cols-2 gap-3">
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1">Nome</label>
                  <input
                    v-model="form.user.first_name"
                    type="text"
                    placeholder="Seu nome"
                    required
                    class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  />
                </div>
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1">Sobrenome</label>
                  <input
                    v-model="form.user.last_name"
                    type="text"
                    placeholder="Seu sobrenome"
                    required
                    class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  />
                </div>
              </div>

            <div>
              <label class="block text-sm font-medium text-gray-700 mb-1 mt-3">Email</label>
              <input
                v-model="form.user.email"
                type="email"
                placeholder="seu@email.com"
                required
                class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
              />
            </div>

            <div>
              <label class="block text-sm font-medium text-gray-700 mt-3 mb-1">Telefone</label>
              <input
                v-model="form.user.phone"
                type="tel"
                @input="masks.handlePhoneMaskInput"
                placeholder="(00) 00000-0000"
                class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
              />
            </div>
          </div>

          <!-- Password -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Senha</label>
            <input
              v-model="form.user.password"
              type="password"
              placeholder="Mínimo 6 caracteres"
              required
              class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Confirmar Senha</label>
            <input
              v-model="form.user.password_confirmation"
              type="password"
              placeholder="Confirme sua senha"
              required
              class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
          </div>

          <!-- Checkbox de ciência -->
          <div class="pt-2 border-t border-gray-200">
            <label class="flex items-start gap-3 cursor-pointer group">
              <input
                v-model="form.accepted_responsibilities"
                type="checkbox"
                class="mt-1 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
              />
              <span class="text-sm text-gray-700 group-hover:text-gray-900">
                Li e estou ciente das <strong>responsabilidades e políticas de uso</strong> descritas ao lado (ou abaixo, no celular) e concordo em ser responsável por todo o conteúdo que publicar na plataforma.
              </span>
            </label>
          </div>

          <div v-if="error" class="bg-red-50 text-red-600 px-4 py-3 rounded-lg text-sm">
            {{ error }}
          </div>

          <button
            type="submit"
            :disabled="!isFormValid || loading"
            class="w-full bg-indigo-600 text-white py-2 rounded-lg font-semibold hover:bg-indigo-700 transition disabled:opacity-50"
          >
            {{ loading ? 'Criando conta...' : 'Criar Conta' }}
          </button>

          <div class="text-center text-sm mt-4">
            <span class="text-gray-600">Já tem uma conta? </span>
            <button type="button" @click="$emit('switch-to-login')" class="text-indigo-600 font-semibold hover:text-indigo-700">
              Entrar
            </button>
          </div>
        </form>
        </div>

        <!-- Coluna direita: texto explicativo -->
        <div class="order-1 lg:order-2">
          <div class="bg-white/90 backdrop-blur rounded-2xl shadow-lg border border-indigo-100 p-6 md:p-8 lg:sticky lg:top-24">
            <h2 class="text-xl font-bold text-indigo-900 mb-4">Para quem é este cadastro?</h2>
            <p class="text-gray-700 mb-4 leading-relaxed">
              Esta conta é destinada a <strong>anfitriões, imobiliárias e gestores de imóveis</strong> que desejam divulgar e gerenciar suas propriedades para aluguel por temporada. Você terá acesso a ferramentas para cadastrar imóveis, fotos, descrições, preços e reservas.
            </p>

            <h3 class="text-lg font-semibold text-gray-900 mt-6 mb-2">Suas responsabilidades</h3>
            <p class="text-gray-700 mb-4 leading-relaxed">
              Ao criar uma conta, você é o <strong>único responsável</strong> por todo o conteúdo que publicar na plataforma: fotos dos imóveis, textos, descrições e informações de contato. É sua obrigação garantir que esse conteúdo seja <strong>adequado, verdadeiro e em conformidade com a lei</strong>.
            </p>

            <div class="bg-amber-50 border border-amber-200 rounded-lg p-4 mt-4">
              <p class="text-sm text-amber-900 leading-relaxed">
                <strong>Atenção:</strong> Conteúdos inadequados — como imagens pornográficas, ofensas, discriminação ou informações falsas — são proibidos. Também é
                expressamente proibido tentar aplicar golpes cadastrando <strong>imóveis falsos, anunciando propriedades que não existem ou para as quais você não tem autorização</strong>.
                A plataforma pode remover conteúdo e encerrar contas que violem essas regras. Em casos graves, o responsável pela conta pode ser acionado judicialmente.
              </p>
            </div>

            <p class="text-sm text-gray-600 mt-6 leading-relaxed">
              Ao marcar a opção "Li e estou ciente" no formulário, você confirma que leu estas informações e se compromete a publicar apenas conteúdo apropriado, ofertas verdadeiras e a responder pelas suas publicações.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { useBrazilianMasks } from '../composables/useBrazilianMasks.js'
import { BRAZILIAN_STATES } from '../constants/brazilianStates.js'

export default {
  emits: ['register-success', 'switch-to-login', 'go-back'],
  
  data() {
    return {
      loading: false,
      error: '',
      masterCodeError: '',
      masks: useBrazilianMasks(),
      stateOptions: BRAZILIAN_STATES,
      form: {
        accepted_responsibilities: false,
        tenant: {
          name: '',
          master_code: '',
          phone: '',
          city: '',
          state: '',
          instagram_profile: '',
          facebook_profile: ''
        },
        user: {
          email: '',
          phone: '',
          first_name: '',
          last_name: '',
          password: '',
          password_confirmation: ''
        }
      }
    }
  },

  computed: {
    isFormValid() {
      // Verificar se todos os campos obrigatórios estão preenchidos
      const tenantValid = this.form.tenant.name.trim() !== '' && 
                         this.form.tenant.master_code.trim() !== '' &&
                         this.form.tenant.phone.trim() !== '' &&
                         this.form.tenant.city.trim() !== '' &&
                         this.form.tenant.state.trim() !== ''
      
      const userValid = this.form.user.first_name.trim() !== '' &&
                       this.form.user.last_name.trim() !== '' &&
                       this.form.user.email.trim() !== '' &&
                       this.form.user.password.trim() !== '' &&
                       this.form.user.password_confirmation.trim() !== ''
      
      // Verificar se não há erro no master code
      const noMasterCodeError = !this.masterCodeError
      
      // Verificar se as senhas coincidem
      const passwordsMatch = this.form.user.password === this.form.user.password_confirmation

      // Deve ter aceitado as responsabilidades
      const acceptedResponsibilities = this.form.accepted_responsibilities === true

      // Pelo menos um perfil social
      const hasSocialProfile =
        this.form.tenant.instagram_profile.trim() !== '' ||
        this.form.tenant.facebook_profile.trim() !== ''
      
      return tenantValid && userValid && noMasterCodeError && passwordsMatch && acceptedResponsibilities && hasSocialProfile
    }
  },

  methods: {
    onTenantPhoneInput(event) {
      this.masks.handlePhoneInput(event, this.form.tenant)
    },
    goBack() {
      const path = window.location.pathname || '/'
      const match = path.match(/^\/([a-zA-Z0-9_-]+)$/)
      const backPath = match && match[1] ? path : '/'
      window.history.pushState({}, document.title, backPath)
      this.$emit('go-back')
    },
    validateMasterCode() {
      const masterCode = this.form.tenant.master_code
      
      // Limpar erro se o campo estiver vazio
      if (!masterCode) {
        this.masterCodeError = ''
        return
      }
      
      // Validar comprimento
      if (masterCode.length < 3) {
        this.masterCodeError = 'Ambiente deve ter pelo menos 3 caracteres'
        return
      }

      if (masterCode.length > 25) {
        this.masterCodeError = 'Ambiente deve ter no máximo 25 caracteres'
        return
      }
      
      // Validar caracteres permitidos
      if (!/^[a-zA-Z0-9_-]+$/.test(masterCode)) {
        this.masterCodeError = 'Apenas letras, números, hífen e underscore são permitidos. Sem espaços ou acentos.'
        return
      }
      
      // Se passou em todas as validações, limpar o erro
      this.masterCodeError = ''
    },

    async handleRegister() {
      this.loading = true
      this.error = ''

      if (this.form.user.password !== this.form.user.password_confirmation) {
        this.error = 'As senhas não coincidem'
        this.loading = false
        return
      }

      try {
        const response = await axios.post('/api/v1/tenants/register', {
          tenant: {
            name: this.form.tenant.name,
            master_code: this.form.tenant.master_code,
            phone: this.form.tenant.phone || '',
            city: this.form.tenant.city || '',
            state: this.form.tenant.state || '',
            instagram_profile: this.form.tenant.instagram_profile || '',
            facebook_profile: this.form.tenant.facebook_profile || ''
          },
          user: this.form.user
        })

        const data = response.data
        const tenantInactive = data.tenant && data.tenant.active === false
        const noTokens = !data.tenantToken && !data.userToken

        // Só grava localStorage e “loga” se o tenant estiver ativo (homologado)
        if (!tenantInactive && !noTokens) {
          localStorage.setItem('tenantToken', data.tenantToken)
          localStorage.setItem('userToken', data.userToken)
          localStorage.setItem('tenant', JSON.stringify(data.tenant))
          localStorage.setItem('user', JSON.stringify(data.user))
          localStorage.setItem('masterCode', data.tenant.master_code)
        }

        this.$emit('register-success', {
          tenant: data.tenant,
          user: data.user,
          tenantToken: data.tenantToken,
          userToken: data.userToken
        })
      } catch (err) {
        if (err.response?.data?.errors) {
          this.error = err.response.data.errors.join(', ')
        } else {
          this.error = 'Falha ao criar conta. Tente novamente.'
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
